let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("adbVD")).then(() => parcelRequire('fbaeV'));